import React, { useLayoutEffect, useState } from "react"
import { CoreButton } from "../components/CoreButton";
import { CoreForm } from "../components/CoreForm";
import { CoreInput } from "../components/CoreInput";
import { CoreTab } from "../components/CoreTab";
import { CoreTabs } from "../components/CoreTabs";
import { Header } from "../components/Header";
import { Loader } from "./Loader"
import * as RemoteCOnfigService from "../services/remoteconfig.service";
import * as RemoteFileService from "../services/remotefile.service";

import { to } from "../utils/to";
import { RequiredValidation } from "../components/CoreValidations";

export const ConfigurationsView = () => {

    const [process, setProcess] = useState<{ running: boolean, status: string }>({ running: true, status: "" });
    let [termoFile, setTermoFile] = useState<File>(undefined);
    let [updateConfig, setUpdateConfig] = useState(false);
    const [hasFormErrors, setFormError] = useState(false);
    const [config, setConfig] = useState<RemoteConfig>({
        key: "remote-config",
        lastUpdate: "",
        emailConfig: {
            host: "",
            password: "",
            port: 0,
            userName: ""
        }
    });
    const [currentTermo, setCurrentTermo] = useState<RemoteFile>({
        size: 0,
        contentType: "",
        fileName: "",
        name: "",
        owner: "",
        data: null
    })

    const [errors, setErrors] = useState({
        general: false
    })

    const onFormError = (errors: CoreFormErrors) => {
        let hasError = Object.keys(errors).length;
        console.log({ hasError });
    }

    const init = async () => {
        setProcess({ running: true, status: "Carregando configurações..." })
        let [errorConfig, serverConfig] = await to<RemoteConfig>(RemoteCOnfigService.getRemoteConfig());
        if (!errorConfig && serverConfig) {
            console.log({ serverConfig })
            setConfig(serverConfig);
        }

        setProcess({ running: true, status: "Carregando arquivos de template..." });
        let [errorFile, successFile] = await to<RemoteFile[]>(RemoteFileService.listRemoteFile("system", "termo-template"));
        if (!errorFile && successFile) {
            setCurrentTermo(successFile[0]);
        }
        setProcess({ running: false, status: "" })

    }


    const onEmailConfigChange = (event: CoreEventChange) => {

        let name = event.name;
        let value = event.value;

        setConfig({
            ...config,
            emailConfig: {
                ...config.emailConfig,
                [name]: value
            }
        })

        setUpdateConfig(true);

    }


    const onFilesAndTemplateChange = async ({ name, value, files }: CoreEventChange) => {

        if (name === "termoFile") {
            setTermoFile(files[0]);
        }


    }


    const onSave = async () => {
        // Termo file changed?
        if (termoFile) {
            setProcess({ running: true, status: "Salvando novos arquivos de template..." })
            const [error, success] = await to(RemoteFileService.saveRemoteFile(termoFile, "system", "termo-template"));
            setTermoFile(undefined);

        }
        // need to update configs?
        if (updateConfig) {
            setProcess({ running: true, status: "Salvando configurações..." })
            const [error, success] = await to(RemoteCOnfigService.saveRemoteConfig(config));
            setUpdateConfig(false);
        }

        setProcess({ running: false, status: "" });
        init();
    }

    useLayoutEffect(() => {
        init();
    }, [])


    return (
        <div className="flex flex-column flex-1 w-full  bg-gray-100">

            {/* menu */}
            <div className="grid grid-flow-col justify-end gap-2 px-4 pt-4">
                <CoreButton text="SALVAR" schema="success" disabled={process.running || hasFormErrors} onClick={onSave} />
            </div>

            <Header
                title="Configurações"
                description="Altere as configurações gerais da plataforma"
            />

            {/* Body */}
            <div className="rounded p-6 flex flex-1 overflow-hidden">


                {process.running
                    ?
                    <Loader enabled status={process.status} />
                    :
                    <div className="flex flex-1 bg-white p-6 shadow-md overflow-y-scroll">
                        <CoreForm onErrors={onFormError}>

                            <CoreTabs>

                                <CoreTab title="Arquivos e Templates" >

                                    <div className="grid grid-cols-1 gap-6 overflow-auto">

                                        <div className="grid grid-cols-1 place-content-start">
                                            
                                            <span className="text-lg">Termo de Bolsa</span>
                                            <span className="text-sm pb-3">O Arquivo de termo de bolsa é o arquivo que será usado como template para a geração dos termos.</span>

                                            {
                                                currentTermo &&
                                                <div className="flex flex-col pb-3">
                                                    <span className="text-sm">Arquivo atual: {currentTermo.fileName}</span>
                                                    <span className="text-sm">Tipo: {currentTermo.contentType}</span>
                                                </div>
                                            }

                                            <CoreInput
                                                label="Template de Termo"
                                                group="templates"
                                                name="termoFile"
                                                type="file"
                                                placeholder="Atualizar o arquivo que será usado como template para geração de termo"
                                                fileAccept=".docx"
                                                onChange={onFilesAndTemplateChange}
                                            />

                                        </div>
                                    </div>

                                </CoreTab>
                                <CoreTab title="Serviço de E-mail" >
                                    <div className="grid grid-cols-2 gap-6 overflow-auto">

                                        <div className="grid grid-cols-1 place-content-start">

                                            <CoreInput
                                                name="host"
                                                label="Servidor de E-mail"
                                                group="service.email"
                                                value={config.emailConfig.host}
                                                validations={[RequiredValidation]}
                                                onChange={onEmailConfigChange}
                                                type="text"
                                            />

                                            <CoreInput
                                                name="port"
                                                label="Porta de Conexão"
                                                group="service.email"
                                                value={config.emailConfig.port}
                                                validations={[RequiredValidation]}
                                                onChange={onEmailConfigChange}
                                                type="text"
                                            />
                                            <CoreInput
                                                name="username"
                                                label="Usuário de Conexão"
                                                group="service.email"
                                                value={config.emailConfig.userName}
                                                validations={[RequiredValidation]}
                                                onChange={onEmailConfigChange}
                                                type="text"
                                            />
                                            <CoreInput
                                                name="password"
                                                label="Senha de Conexão"
                                                group="service.email"
                                                value={config.emailConfig.password}
                                                validations={[RequiredValidation]}
                                                onChange={onEmailConfigChange}
                                                type="password"
                                            />

                                        </div>

                                    </div>
                                </CoreTab>
                            </CoreTabs>
                        </CoreForm>
                    </div>
                }

            </div>

        </div>

    )
}